import { useQuery } from 'react-query';

import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { getActorSummaryQuery } from '@savgroup-front-common/core/api/Actor/getActorSummaryQuery';
import { ActorSummary } from '@savgroup-front-common/types';

export const GetActorSummaryQuery = 'getActorSummaryQuery';

interface UseGetActorSummaryArgs {
  actorId?: string;
  actorType?: string;
  sellerId?: string;
  ownerId?: string;
}

interface UseGetActorSummaryReturnValues {
  actorSummary?: ActorSummary;
  isLoading: boolean;
}

const useGetActorSummary = ({
  actorId,
  actorType,
  sellerId,
  ownerId,
}: UseGetActorSummaryArgs): UseGetActorSummaryReturnValues => {
  const { data: actorSummary, isLoading } = useQuery(
    [GetActorSummaryQuery, { actorId, actorType, sellerId, ownerId }],
    async () => {
      const response = await getActorSummaryQuery({
        actorId,
        actorType,
        sellerId,
        ownerId,
      });

      if (response.failure) {
        logError(response.errors);

        return undefined;
      }

      return response.value;
    },
    { staleTime: Infinity, enabled: Boolean(actorType) },
  );

  return { actorSummary, isLoading };
};

export default useGetActorSummary;
